import * as React from 'react';
// @ts-ignore
import AdminUpgradePageHeader from 'admin/components/AdminUpgradePageHeader';
import { UpgradePlanData, UpgradePlanQuote, UpgradePlanTab, UpgradePlanTabKey } from 'admin/components/AdminUpgradePlan/AdminUpgradePlanContainer';

import '../styles/AdminUpgradePlanForms.scss';

type Props = {
  tabs: UpgradePlanTab[],
  fields: UpgradePlanData,
  quote: UpgradePlanQuote,
  currentTab?: UpgradePlanTab,
  onCardInputCompleted: () => void,
  onPersistState: (fields: UpgradePlanData, onSuccess: Function) => void,
  onTaxChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
}

type State = {
  currentTab: UpgradePlanTab,
}


class AdminUpgradePlanForms extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      currentTab: props.currentTab || props.tabs[0],
    };
  }

  advanceTab = () => {
    const { nextStep } = this.state.currentTab;
    const newTab = this.props.tabs.find(tab => tab.tabKey === nextStep);
    if (newTab) {
      this.setState({ currentTab: newTab });
    }
  };

  render() {
    const {
      fields,
      onCardInputCompleted,
      onPersistState,
      onTaxChange,
      quote,
    } = this.props;
    const { currentTab } = this.state;
    const CurrentTab = currentTab.component;

    return (
      <div className="AdminUpgradePlanForms">
        <AdminUpgradePageHeader title="The Remind plan" hideHelp />
        <div className="AdminUpgradePlanForms-body">
          <CurrentTab
            {...fields}
            quote={quote}
            onAdvance={this.advanceTab}
            onCardInputCompleted={onCardInputCompleted}
            onPersistState={onPersistState}
            onTaxChange={onTaxChange}
          />
        </div>
      </div>
    );
  }
}


export { AdminUpgradePlanForms };
export default AdminUpgradePlanForms;
